<template>
  <div class="animated fadeIn">
    <b-row class="mb-4">
      <b-col md="12" lg="3" xl="2">
        <h2 class="pr-3 my-1 mb-3 mb-lg-0 pageinfo text-center text-lg-left">Dashboard</h2>
      </b-col>
      <b-col md="3" lg="2">
        <b-dropdown
          class="custom_dropdown custom_dropdown_b my-1"
          @show="activate_custom_backdrop"
          @hidden="deactivate_custom_backdrop"
          variant="info"
          :text="ec_filter"
          title="Energy Company"
        >
          <b-dropdown-item @click="ecFilter('All Energy Companies', 0)">All Energy Companies</b-dropdown-item>
          <b-dropdown-item
            @click="ecFilter(energy_company_filter.name, energy_company_filter.id)"
            v-for="energy_company_filter in energy_companies_filter"
          >{{energy_company_filter.name}}</b-dropdown-item>
        </b-dropdown>
      </b-col>
      <b-col md="3" lg="2" class="my-1" title="Initial Date">
        <b-form-input
          id="haul_start_datetime"
          v-model="filter_by.initial_date"
          @input="iFilter()"
          type="date"
        ></b-form-input>
      </b-col>
      <b-col md="3" lg="2" class="my-1" title="End date">
      <b-form-input
          id="haul_end_datetime"
          v-model="filter_by.end_date"
          @input="eFilter()"
          type="date"
      ></b-form-input>
      </b-col>
      <b-col md="3" lg="2">
        <b-dropdown
          class="custom_dropdown custom_dropdown_b my-1"
          @show="activate_custom_backdrop"
          @hidden="deactivate_custom_backdrop"
          variant="info"
          :text="oa_filter"
          title="Operating Area"
        >
          <b-dropdown-item @click="oaFilter('All Operating Areas', 0)">All Operating Areas</b-dropdown-item>
          <b-dropdown-item
            @click="oaFilter(operating_area_filter.name, operating_area_filter.id)"
            v-for="operating_area_filter in operating_areas_filter"
          >{{operating_area_filter.name}}</b-dropdown-item>
        </b-dropdown>
      </b-col>
      <b-col md="1">
        <b-btn @click="clearFilters()" class="pull-right pull-sm-left my-1" variant="info">Clear</b-btn>
      </b-col>
      <b-col>
         <b-btn v-if="(load_locations_id.length > 0 || unload_locations_id.length > 0)" class="pull-right my-1" @click="generate_chart_click()" variant="info">Generate Chart</b-btn>
      </b-col>
    </b-row>

    <!-- Graph 0 margin-bottom: 0; line-height: 17px;-->
    <b-row>
      <b-col sm="6" lg="6">
        <b-card no-body class="bg-targets cart-100">
          <b-card-body class="pb-0">
            <h4 style="line-height: 20px; margin-bottom: 5px;">Alerts</h4>
            <br />
            <p
              onmouseover="this.style.cursor='pointer'"
              v-on:click="alert_filter('Unknow Load Location',13)"
              style="margin-bottom: 0; line-height: 17px;"
            >Unknow Load Location : {{alerts.unknow_load_location}} </p>
            <br />
            <p
              onmouseover="this.style.cursor='pointer'"
              v-on:click="alert_filter('Price Anomaly',14)"
              style="margin-bottom: 0; line-height: 17px;"
            >Price Anomaly        : {{alerts.price_anomaly}}</p>
            <br />
            <p
              onmouseover="this.style.cursor='pointer'"
              v-on:click="alert_filter('Duplicated Truck Ticket',15)"
              style="margin-bottom: 0; line-height: 17px;"
            >Duplicated Truck Ticket : {{alerts.duplicated_truck_ticket}}</p>
            <br />
            <p
              onmouseover="this.style.cursor='pointer'"
              v-on:click="alert_filter('Drive Time Anomaly',16)"
              style="margin-bottom: 0; line-height: 17px;"
            >Drive Time Anomaly      : {{alerts.drive_time_anomaly}}</p>
            <br />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row  v-if="(unloadlocationselect.length > 0 || loadlocationselect.length > 0)">
      <b-col sm="4" lg="4">	
          <b-row>
	          <b-col>	
			        <b-form-group v-if="loadlocationselect.length > 0" label-size='lg' label-class="font-weight-bold pt-0" id="L5" label="Load Locations" label-for="loadLocationsID" vertical>
				        <b-form-checkbox-group value-field="id" text-field="legal_location"  class="custom-checkboxes" :options="loadlocationselect" name="Checkboxes2" plain v-model="load_locations_id" @input="loadLocationsChange"></b-form-checkbox-group>
				          <b-form-checkbox style="margin-top: 15px;" v-model="llAllSelected" :indeterminate="indeterminateLL" aria-describedby="" aria-controls="" plain @change="LLToggleAll">
					            {{ llAllSelected ? 'Un-select All' : 'Select All' }}
				          </b-form-checkbox>
			        </b-form-group>
              <span v-else>No Load locations</span>
             </b-col>  
          </b-row> 
          <b-row>
            <b-col>	
			      <b-form-group v-if="unloadlocationselect.length > 0" label-size='lg' label-class="font-weight-bold pt-0" id="L5" label="Unload Locations" label-for="unloadLocationsID" vertical>
				      <b-form-checkbox-group value-field="id" text-field="legal_location" class="custom-checkboxes" :options="unloadlocationselect" name="Checkboxes2" plain v-model="unload_locations_id" @input="unloadLocationsChange"></b-form-checkbox-group>
				        <b-form-checkbox style="margin-top: 15px;" v-model="ulAllSelected" :indeterminate="indeterminateUL" aria-describedby="" aria-controls="" plain @change="ULToggleAll">
					        {{ ulAllSelected ? 'Un-select All' : 'Select All' }}
				        </b-form-checkbox>
			      </b-form-group>
            <span v-else>No Unload locations</span>
            </b-col>
        </b-row>  
      </b-col>
      <b-col sm="8" lg="8">
        <b-card no-body class="chart-wrapper" bg-variant="light">
          <b-container>
            <b-row>
              <b-col>
                <highcharts class="chart" :options="chart"></highcharts>
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-if="users_select.length >0 && (load_locations_id.length > 0 || unload_locations_id.length > 0)">
      <b-col sm="4" lg="4">	
        <b-row>		
          <b-col>	
			      <b-form-group v-if="users_select.length > 0" label-size='lg' label-class="font-weight-bold pt-0" id="L6" label="Drivers" label-for="userID" vertical>
				      <b-form-checkbox-group value-field="id" text-field="name"  class="custom-checkboxes" :options="users_select" name="Checkboxes2" plain v-model="users_id" @input="user_Change"></b-form-checkbox-group>
				          <b-form-checkbox style="margin-top: 15px;" v-model="user_AllSelected" :indeterminate="indeterminate_user" aria-describedby="" aria-controls="" plain @change="user_ToggleAll">
					          {{ user_AllSelected ? 'Un-select All' : 'Select All' }}
				      </b-form-checkbox>
			      </b-form-group>
        <p v-else>No Users</p>
        </b-col>
        </b-row>    
      </b-col>
      <b-col sm="8" lg="8">
        <b-card no-body class="chart-wrapper" bg-variant="light">
          <b-container>
            <b-row>
              <b-col>
                <highcharts class="chart" :options="chart_users"></highcharts>
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </b-col>
    </b-row>
    <b-modal  ref="newHaulModal" title="Notification" v-model="newEC" size="lg" hide-footer no-close-on-backdrop no-close-on-esc>
    <div class="table-responsive p-0 m-0">
          <b-table           
            hover 
            show-empty 
            stacked="md" 
            :items="notification"
            :fields="fields"           
          >
          <template slot="action" slot-scope="row">
            <b-button size="sm" @click="adjust(row.item, row.index)" class="mr-1">
            Accept
            </b-button>    
          </template>
          <template slot="action1" slot-scope="row">   
            <b-button size="sm" @click="ignore(row.item, row.index)" class="mr-1">
            Ignore
            </b-button> 
          </template>
          </b-table> 
    </div>    
    </b-modal> 
    <!--class="newHaulModal" bordered striped class="animated fadeIn" <b-row></b-row> <b-col cols="12"> </b-col> hide-header-close   -->
  </div>
</template>

<script>
import dashboard_service from "./dashboard_service"
import haul_service from '../hauls/haul_service'
import { Chart } from "highcharts-vue";
export default {
  created: function() {
   if (localStorage.getItem("role") == "trucking_company_admin" || localStorage.getItem("role") == "trucking_operational_manager") {
      this.getAlerts();
      this.dashboard()
    }
  },
  data() {
    return {
        alerts        : {},
        role          : '',
        notification  : [],
        newEC         : false,
        fields: [
        {
          key: 'energy_company',
          label: 'Energy Company',
        }, {
          key: 'operating_area',
          label: 'Operating Area',
        },
        {
          key: 'load_location',
          label: 'Load',
        }, {
          key: 'unload_location',
          label: 'Unload',
          sortable: false,
        }, {
          key: 'volume',
          label: 'Volume',
          sortable: false,
          formatter: (value) => { return Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' m³' }
        },
        {
          key: 'dispatch_date',
          label: 'Dispatch Date',
          sortable: false,
          formatter:(value) => { return moment(value).format("MMM DD, YYYY") }
        },
        { key: 'action',
          label: '    '
        },
        { key: 'action1',
          label: '     '
        }
        ],
        // new
        oa_filter: "All Operating Areas",
        ec_filter: "All Energy Companies",
        filter_by: {
          energy_company_id   : "",
          trucking_company_id : "",
          initial_date        : moment()
            .startOf("month")
            .format("YYYY-MM-DD"),
          end_date            : moment()
            .endOf("month")
            .format("YYYY-MM-DD"),
          operating_area_id   : "",
          users               : [], 
          load_locations      : [],
          unload_locations    : [],         
        },
        energy_companies_filter   : [],
        operating_areas_filter    : [],
        loadlocationselect    : [],
        unloadlocationselect  : [],
        indeterminateLL       : false,
			  llAllSelected         : false,
			  indeterminateUL       : false,
			  indeterminate         : false,
        ulAllSelected         : false,
        load_locations_id     : [],
        unload_locations_id   : [],
        users_select          : [],
        users_id              : [],
        indeterminate_user    : false,
        user_AllSelected      : false,
        chart_users           : {
          'chart' : { 'backgroundColor' : '#37393F',
                      'height'          : 600
                  }
        },
              chart                 : {
        'chart' : { 'backgroundColor' : '#37393F',
                      'height'          : 600
                  }
        },
        chart_activated       : false,
    }
  },
  beforeCreate: function() {
    if (!localStorage.getItem("access_token")) {
      this.$router.replace("/login");
    }
    if (localStorage.getItem("role") == "trucking_company_admin" || localStorage.getItem("role") == "trucking_operational_manager") {
      // this.$router.replace("/hauls/");
      this.$router.replace("/dash/");
    }
    if (localStorage.getItem("role") == "trucking_company_admin_light") {
      this.$router.replace("/users/");
    }
  },
  methods: {
    getAlerts() {
      dashboard_service
        .getAlerts_tc()
        .then(data => {
          if (data.status == "success") {
            this.alerts = data.alerts
            this.role   = data.role
            this.notification = data.notification
            if (this.notification.length != 0) {
              this.newEC = true
            }
          }
        })
        .catch(error => {
          this.$swal("Error", "Server not response. " + error, "error");
        });
    },
    alert_filter(flag,flag_id){
        localStorage.setItem("dashboard", "dash09");
        localStorage.setItem("dashboard_flag_name", flag);
        localStorage.setItem("dashboard_flag_id", flag_id);
        var currentUrl = "http://" + window.location.host + "/#/hauls";
        window.location.href = currentUrl;
        return;
    },
    adjust(item, index) {
        let accepted = {'status_id': 5 }            
            haul_service.update_request(accepted,item['haul_id'] )
                .then((data) => {
                    if (data.status == 'success') {
                        //Vue.swal(data.status, data.message, data.status)
                        this.notification.splice(index, 1 )
                    }else{
                        //Vue.swal(data.status, data.message, data.status)
                        console.log('bad')
                    }
            })
    },
    ignore(item, index) {
      this.notification.splice(index, 1 )
    },
    activate_custom_backdrop() {
        this.$root.$el.classList.add("custom_backdrop_behavior");
    },
    deactivate_custom_backdrop() {
        this.$root.$el.classList.remove("custom_backdrop_behavior");
    },
    iFilter() {
      if (this.filter_by["end_date"] == "" || !this.filter_by["end_date"]) {
        this.filter_by["end_date"] = "";
      }
      this.getDashboard();
      this.getAlerts();
      this.getAvgDailyDistance();
      this.getWaitTimeChart();
      // this.getTargetChart();
      this.getAvgMinuteLoadChart();
      this.getFluidByLoadChart();
      this.getFluidByUnloadChart();
      this.getTargetList();
      this.loadingData = true;
    },
    eFilter() {
      if (
        this.filter_by["initial_date"] == "" ||
        !this.filter_by["initial_date"]
      ) {
        this.filter_by["initial_date"] = "";
      }
    },
    clearFilters() {
      this.ec_filter = "All Energy Companies";
      this.filter_by = {
        energy_company_id: "",
        trucking_company_id: "",
        initial_date: moment()
          .startOf("month")
          .format("YYYY-MM-DD"),
        end_date: moment()
          .endOf("month")
          .format("YYYY-MM-DD"),
        operating_area_id: ""
      };
      
    },
    ecFilter(ec_filter, id) {
      this.ec_filter = ec_filter;
      this.filter_by["energy_company_id"] = id;
      this.oa_filter = "All Operating Areas";
      if (id!==0) {       
        let pos = this.energy_companies_filter
          .map(o => o.id)
          .indexOf(this.filter_by["energy_company_id"]);
            if (pos > -1) {
                this.operating_areas_filter     = this.energy_companies_filter[pos].operating_areas;
                this.filter_by["operating_area_id"] = ''
                this.location_list()
                this.load_locations_id    = []
                this.unload_locations_id  = []
                this.users_id             = [] 
                this.user_Change()
            } else {
                this.operating_areas_filter     = []            
                this.loadlocationselect         = []
                this.unloadlocationselect       = [] 
                this.filter_by["operating_area_id"] = '' 
                this.load_locations_id    = []
                this.unload_locations_id  = []  
                this.users_id             = [] 
                 this.user_Change()      
            }
      } else {
          this.filter_by['energy_company_id'] = ''
          this.filter_by["operating_area_id"] = ''
          this.ec_list()
          this.location_list()
          this.load_locations_id    = []
          this.unload_locations_id  = []
          this.users_id             = [] 
          this.user_Change()
      }
    },
    oaFilter(oa_filter, id) {
      this.oa_filter = oa_filter;
      this.filter_by["operating_area_id"] = id;
      if (id == 0) {
        this.filter_by["operating_area_id"] = "";
      }
      this.location_list()
    },
    dashboard() {
      dashboard_service
        .dashboard_tc()
        .then(data => {
          if (data.status == "success") {
            //this.trucking_company_filter  = data.trucking_company_filter
            this.users_select             = data.trucking_company_filter[0].drivers
            this.energy_companies_filter  = data.trucking_company_filter[0].energy_companies            
            this.filter_by['trucking_company_id']            = data.trucking_company_filter[0].id
            this.ec_list()
            this.location_list()
          } else {
            this.$swal(data.status, data.message, data.status);
            return;
          }
        })
        .catch(error => {
          this.$swal("Error", "Server not response. " + error, "error");
        });
    },
    location_list() {  
        this.loadlocationselect   = []
        this.unloadlocationselect = []        
        let location = this.operating_areas_filter       
        if (this.filter_by["operating_area_id"] === "") {
            let new_unloadlocations = []
            let new_loadlocations   = []
            location.map( item => {
              item.loads.forEach( element => { 
                 let index2 = new_loadlocations.map(o => o.id).indexOf(element.id)
                 if (index2 < 0) {
                      new_loadlocations.push(element)
                 }
              })
              item.unloads.forEach( element => { 
                 let index1 = new_unloadlocations.map(o => o.id).indexOf(element.id)
                 if (index1 < 0) {
                      new_unloadlocations.push(element)
                 }
              })              
            })
            if (new_unloadlocations.length>0) {
                let mapped = new_unloadlocations.map(function(el, i) {
                    return { index: i, value: el.legal_location.toLowerCase() };
                })
                mapped.sort( (a,b) => {   if (a.value > b.value) {
                                              return 1;
                                          }
                                          if (a.value < b.value) {
                                              return -1;
                                          }
                                          return 0;
                                      })
                this.unloadlocationselect = mapped.map(function(el){
                                                        return new_unloadlocations[el.index];
                                                      });
            }
            if (new_loadlocations.length>0) {
                let mapped1 = new_loadlocations.map(function(el, i) {
                    return { index: i, value: el.legal_location.toLowerCase() };
                })
                mapped1.sort( (a,b) => {   if (a.value > b.value) {
                                              return 1;
                                          }
                                          if (a.value < b.value) {
                                              return -1;
                                          }
                                          return 0;
                                      })
                this.loadlocationselect = mapped1.map(function(el){
                                                        return new_loadlocations[el.index];
                                                      });
            }

        } else {
            let index =location.map(o => o.id).indexOf(this.filter_by["operating_area_id"])
					  if (index > -1) {
              this.loadlocationselect = location[index].loads
              this.unloadlocationselect = location[index].unloads
            }            
        }
    },
    LLToggleAll(checked) {
				this.load_locations_id = checked ? this.loadlocationselect.map(item => {
					return item.id
				}) : []
		},
		ULToggleAll(checked) {
				this.unload_locations_id = checked ? this.unloadlocationselect.map(item => {
					return item.id
				}) : []
		},
    user_ToggleAll(checked) {
				this.users_id = checked ? this.users_select.map(item => {
					return item.id
				}) : []
		},
		loadLocationsChange() {
					if (this.load_locations_id.length === 0) {
						this.indeterminateLL = false
						this.llAllSelected = false
					} else if (this.load_locations_id.length === this.loadlocationselect.length) {
						this.indeterminateLL = false
						this.llAllSelected = true
					} else {
						this.indeterminateLL = true
						this.llAllSelected = false
					}
		},
		unloadLocationsChange() {
					if (this.unload_locations_id.length === 0) {
						this.indeterminateUL = false
						this.ulAllSelected = false
					} else if (this.unload_locations_id.length === this.unloadlocationselect.length) {
						this.indeterminateUL = false
						this.ulAllSelected = true
					} else {
						this.indeterminateUL = true
						this.ulAllSelected = false
				  }
    },
    user_Change() {
					if (this.users_id.length === 0) {
						this.indeterminate_user = false
						this.user_AllSelected = false
					} else if (this.users_id.length === this.users_select.length) {
						this.indeterminate_user = false
						this.user_AllSelected = true
					} else {
						this.indeterminate_user = true
						this.user_AllSelected = false
				  }
    },
    generate_chart_click() {
       this.get_volume_by_date_chart()
       this.get_volume_by_date_user_chart()
    },
    get_volume_by_date_chart() {
      this.filter_by['load_locations']   = this.load_locations_id
      this.filter_by['unload_locations'] = this.unload_locations_id
      dashboard_service
        .get_volume_by_date(this.filter_by)
        .then(data => {
          if (data.status == "success") {
            this.chart = data.volume_by_date_chart
          }  else {
            this.$swal(data.status, data.message, data.status);
            return;
          }
        })
        .catch(error => {
          this.$swal("Error", "Server not response. " + error, "error");
        });
    },
    get_volume_by_date_user_chart() {
      this.filter_by['load_locations']   = this.load_locations_id
      this.filter_by['unload_locations'] = this.unload_locations_id  
      this.filter_by['users']            = this.users_id   
      dashboard_service
        .get_volume_user(this.filter_by)
        .then(data => {
          if (data.status == "success") {
            this.chart_users = data.volume_by_date_user_chart
          }
        })
        .catch(error => {
          this.$swal("Error", "Server not response. " + error, "error");
          this.loadingData = false;
        });
    },
    ec_list() {
        this.operating_areas_filter   = []    
        let energy_companies = this.energy_companies_filter      
        if (this.filter_by["energy_company_id"] === "") {            
            energy_companies.map( item => {
              item.operating_areas.forEach( element => { 
                 this.operating_areas_filter.push(element)
              })             
            })
        } else {
            let index =energy_companies.map(o => o.id).indexOf(this.filter_by["energy_company_id"])
					  if (index > -1) {
              this.operating_areas_filter = energy_companies[index].operating_areas
            }            
        }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/dashboard/Dash.vue